import React from 'react';
import { allow } from '../classes/allow';
import cloneObject from './clone.object';
import { isAnObject } from './is.an.object';

export default function cloneArray(array = []) {
   allow.anArray(array);
   return array.map(element => {
      if (React.isValidElement(element))
         return element;
      if (isAnObject(element))
         return cloneObject(element);
      if (Array.isArray(element))
         return cloneArray(element);
      return element;
   });
};